export const TOGGLE_FILTER = 'TOGGLE_FILTER'